export class Subscription {
  public SubscriptionId = '';
  public SubscriptionStatus = '';
  public SubscriptionContractDate = '';
  public SubscriptionEndDate = '';
  public SubscriptionStartDate = '';
  public SubscriptionOrganizationId = '';
  public SubscriptionOrganizationName = '';
  public SubscriptionPlanId = '';
  public SubscriptionPlanName = '';
  public SubscriptionPrice = '';
  public SubscriptionUserGamId = '';
  public SubscriptionUserId = '';
  public SubscriptionUserName = '';

  constructor() { }

  public static parse(data: any): Subscription {
    const subscription = new Subscription();

    if (data) {
      if (data.SubscriptionId || data.SuscripcionId) {
        subscription.SubscriptionId = data.SubscriptionId || data.SuscripcionId;
      }
      if (data.SubscriptionStatus || data.SuscripcionEstado) {
        subscription.SubscriptionStatus = data.SubscriptionStatus || data.SuscripcionEstado;
      }
      if (data.SubscriptionContractDate || data.SuscripcionFechaContrato) {
        subscription.SubscriptionContractDate = data.SubscriptionContractDate || data.SuscripcionFechaContrato;
      }
      if (data.SubscriptionEndDate || data.SuscripcionFechaFin) {
        subscription.SubscriptionEndDate = data.SubscriptionEndDate || data.SuscripcionFechaFin;
      }
      if (data.SubscriptionStartDate || data.SuscripcionFechaInicio) {
        subscription.SubscriptionStartDate = data.SubscriptionStartDate || data.SuscripcionFechaInicio;
      }
      if (data.SubscriptionOrganizationId || data.SuscripcionOrganizacionId) {
        subscription.SubscriptionOrganizationId = data.SubscriptionOrganizationId || data.SuscripcionOrganizacionId;
      }
      if (data.SubscriptionOrganizationName || data.SuscripcionOrganizacionNombre) {
        subscription.SubscriptionOrganizationName = data.SubscriptionOrganizationName || data.SuscripcionOrganizacionNombre;
      }
      if (data.SubscriptionPlanId || data.SuscripcionPlanId) {
        subscription.SubscriptionPlanId = data.SubscriptionPlanId || data.SuscripcionPlanId;
      }
      if (data.SubscriptionPlanName || data.SuscripcionPlanNombre) {
        subscription.SubscriptionPlanName = data.SubscriptionPlanName || data.SuscripcionPlanNombre;
      }
      if (data.SubscriptionPrice || data.SuscripcionPrecio) {
        subscription.SubscriptionPrice = data.SubscriptionPrice || data.SuscripcionPrecio;
      }
      if (data.SubscriptionUserGamId || data.SuscripcionUsuarioGamId) {
        subscription.SubscriptionUserGamId = data.SubscriptionUserGamId || data.SuscripcionUsuarioGamId;
      }
      if (data.SubscriptionUserId || data.SuscripcionUsuarioId) {
        subscription.SubscriptionUserId = data.SubscriptionUserId || data.SuscripcionUsuarioId;
      }
      if (data.SubscriptionUserName || data.SuscripcionUsuarioNombre) {
        subscription.SubscriptionUserName = data.SubscriptionUserName || data.SuscripcionUsuarioNombre;
      }
    }

    return subscription;
  }
}
